import { useNavigate } from "react-router-dom";

import Cookies from "js-cookie";
import RequestConfig from "../mini_components/RequestConfig";
import AlertButton from "./AlertButton";
import icons from "../lib/icons";

function Logout() {
  const navigate = useNavigate();
  const logout = async () => {
    try {
      RequestConfig.post(`/users/logout/`)
        .then((response) => {
          if (response.status === 200) {
            Cookies.remove("token");
            navigate("/");
            return true;
          } else {
            return false;
          }
        })
        .catch((err) => {
          return false;
        })
        .finally(() => {
          return false;
        });
    } catch (error) {
      return false;
    }
    return false;
  };

  const handleLogout = async () => {
    const isLoggedOut = await logout();
    if (isLoggedOut) {
      //console.log("handle");
    }
  };

  return (
    <AlertButton onClick={handleLogout}>
      <div className="btn-exit flex items-center gap-1 hover:scale-105">
        <img src={icons.logout} alt="" width={16} height={16} />
      <p>خروج از حساب کاربری</p>
      </div>
    </AlertButton>
  );
}

export default Logout;
